// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-9f5670f0] {\n  text-align: center;\n  font-weight: bold;\n  font-size: 2rem;\n}\n.body[data-v-9f5670f0] {\n  margin-top: 20px;\n  text-align: center;\n  font-size: 1.1rem;\n}\n.body b[data-v-9f5670f0] {\n  display: block;\n  margin-top: 15px;\n  word-wrap: break-word;\n  line-height: 1.4;\n}\n.btn[data-v-9f5670f0] {\n  margin-top: 30px;\n}", ""]);
// Exports
module.exports = exports;
